import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-center mb-5"
};
const _hoisted_2 = {
    key: 0,
    class: "mb-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_logo = _resolveComponent("g-logo");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.showLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_g_logo, { "logo-mode": "simple" })
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", null, [
            (_ctx.title)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
                    (_ctx.backLinkPath)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _ctx.backLinkPath,
                            tabindex: "-1"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/arrow-left.svg",
                                    class: "mb-1 color__text-gray"
                                })
                            ]),
                            _: 1
                        }, 8, ["to"]))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                ]))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
        ])
    ], 64));
}
